import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { INotificationListItem, INotificationReducerState } from "../../interfaces";
import { AlertProps } from "@mui/material";

const initialState: INotificationReducerState = {
	loading: false,
	success: false,
	error: "",
	currentAction: "",
	notifications: [],
	showNotifications: true,
	feedbackNotification: {
		show: false,
		message: ""
	}
};

const notifications = createSlice({
	name: "notifications",
	initialState: initialState,
	reducers: {
		addNotification: (state, { payload }: PayloadAction<INotificationListItem>) => {
			state.notifications.push(payload);
		},
		removeNotification: (state, { payload }: PayloadAction<string>) => {
			const updatedNotifications = state.notifications.filter((item) => item.messageId !== payload);
			state.notifications = updatedNotifications;
		},
		clearNotifications: (state) => {
			state.loading = false;
			state.success = false;
			state.error = "";
			state.currentAction = "";
			state.notifications = [];
		},
		toggleShowNotifications: (state) => {
			state.showNotifications = !state.showNotifications;
			state.notifications = [];
		},
		showFeedbackNotification: (
			state,
			{ payload }: PayloadAction<{ message: string; severity?: AlertProps["severity"] }>
		) => {
			state.feedbackNotification = {
				show: true,
				message: payload.message,
				severity: payload.severity
			};
		},
		hideFeedbackNotification: (state) => {
			state.feedbackNotification.show = false;
		}
	}
});

export const {
	addNotification,
	removeNotification,
	clearNotifications,
	toggleShowNotifications,
	showFeedbackNotification,
	hideFeedbackNotification
} = notifications.actions;

export default notifications;
